import Button from '@mui/material/Button';
import type { ButtonProps } from '@mui/material/Button/Button';

import { ReactComponent as ArrowLeftSvg } from '../../assets/icons-14/arrow-left.svg';
import { ReactComponent as ArrowRightSvg } from '../../assets/icons-14/arrow-right.svg';

import './uni-credit-text-button.scss';
import './uni-credit-text-button-colors.scss';

import type { UniCreditColors } from '../uni-credit-typography';

export type UniCreditTextButtonProps = {
  color?: UniCreditColors,
  startArrow?: boolean,
  endArrow?: boolean,
} & Omit<ButtonProps, 'color'>;

function UniCreditTextButton({
  className = '',
  color = 't2',
  startArrow,
  endArrow,
  children,
  ...props
}: UniCreditTextButtonProps) {
  return (
    <Button
      variant="text"
      className={!props.component ? `${className} uni-credit-text-button uni-credit-text-button-${color}` : ''}
      startIcon={startArrow ? <ArrowLeftSvg /> : null}
      endIcon={endArrow ? <ArrowRightSvg /> : null}
      {...props}
    >{children}</Button>
  );
}

export default UniCreditTextButton;